module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newMsg"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v(_vm._s(_vm.actionText) + "\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveMsg
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "消息用途：",
      "prop": "msgPurpose"
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "placeholder": "请输入消息用途",
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.form.msgPurpose),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgPurpose", $$v)
      },
      expression: "form.msgPurpose"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消息类型:",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.form.msgType),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgType", $$v)
      },
      expression: "form.msgType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "类型一",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "类型二",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "类型三",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推送范围:",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.form.pushRange),
      callback: function($$v) {
        _vm.$set(_vm.form, "pushRange", $$v)
      },
      expression: "form.pushRange"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部学校",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "部分学校",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "部分学生",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.pushRange == '2') ? _c('div', {
    staticStyle: {
      "margin": "20px 20px 20px 160px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%",
      "display": "inline-block"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.school),
      callback: function($$v) {
        _vm.school = $$v
      },
      expression: "school"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.rootUnid,
      attrs: {
        "label": item.name,
        "value": item.rootUnid
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.edit
    },
    on: {
      "click": _vm.addCamp
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('div', {
    staticClass: "campsBox"
  }, _vm._l((_vm.schoolsArr), function(item, $index) {
    return _c('div', {
      staticClass: "s_item"
    }, [_vm._v(_vm._s(item.name) + "\n                        "), _c('i', {
      staticClass: "el-icon-circle-close closeIcon",
      on: {
        "click": function($event) {
          return _vm.delCampOrStu($index, 1)
        }
      }
    })])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.form.pushRange == '3') ? _c('div', {
    staticStyle: {
      "margin": "20px 20px 20px 160px"
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "placeholder": "请输入uid",
      "type": "number"
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.edit
    },
    on: {
      "click": _vm.addStu
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('div', {
    staticClass: "campsBox"
  }, _vm._l((_vm.studentArr), function(item, $index) {
    return _c('div', {
      staticClass: "s_item"
    }, [_vm._v(_vm._s(item) + "\n                        "), _c('i', {
      staticClass: "el-icon-circle-close closeIcon",
      on: {
        "click": function($event) {
          return _vm.delCampOrStu($index, 0)
        }
      }
    })])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.form.msgType != '3' && !_vm.edit) ? _c('el-form-item', {
    attrs: {
      "label": "封面图标:",
      "prop": "coverPic"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或\n                        "), _c('em', [_vm._v("点击上传")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.form.msgType != '3') ? _c('el-form-item', {
    attrs: {
      "label": "标题：",
      "prop": "msgHeadline"
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.form.msgHeadline),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgHeadline", $$v)
      },
      expression: "form.msgHeadline"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.msgType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "副标题：",
      "prop": "msgSubheadline"
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "placeholder": "请输入副标题"
    },
    model: {
      value: (_vm.form.msgSubheadline),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgSubheadline", $$v)
      },
      expression: "form.msgSubheadline"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.msgType != '1') ? _c('el-form-item', {
    attrs: {
      "label": "消息内容：",
      "prop": "msgContent"
    }
  }, [_c('el-input', {
    staticClass: "msgContent",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "placeholder": "请输入消息内容"
    },
    model: {
      value: (_vm.form.msgContent),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgContent", $$v)
      },
      expression: "form.msgContent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.msgType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "跳转h5地址：",
      "prop": "redirectH5Url"
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "placeholder": "请输入h5地址"
    },
    model: {
      value: (_vm.form.redirectH5Url),
      callback: function($$v) {
        _vm.$set(_vm.form, "redirectH5Url", $$v)
      },
      expression: "form.redirectH5Url"
    }
  })], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-661e8431!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/secretary/message/newMsg.vue
// module id = 1055
// module chunks = 0